import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';
import { useRouter } from 'expo-router';
import { MovementIcon } from '../MovementIcon/MovementIcon';
import {
  TTransactionRow,
  TransactionsTable,
} from '../TransactionsTable/TransactionsTable';
import { useItemAction, useItemProps } from './MovementsTable.utils';

export function MovementsTable({
  transactions,
}: {
  transactions: IMovement[];
}) {
  const { getItemProps } = useItemProps();
  const { setParams } = useRouter();

  const handleRowClick = (transaction: IMovement) => {
    setParams({
      orderId: transaction.order?.id,
      categorySlug: transaction.order?.product.category.slug,
    });
  };
  const { getItemAction } = useItemAction(handleRowClick);

  const rows: TTransactionRow[] = transactions.map((transaction) => {
    const itemProps = getItemProps(transaction);
    return {
      icon: (
        <MovementIcon
          type={itemProps.type}
          subcategory={transaction.subcategory}
          pocketType={transaction.pocket.type}
          budgetLogo={transaction.budgetEmployee?.budget.logo}
          isDebit={transaction.isDebit}
        />
      ),
      date: transaction.executedAt,
      description: itemProps.description,
      statusBadge: itemProps.statusBadge,
      amount: transaction.amount,
      isDebit: transaction.isDebit,
      disabled: ['failed', 'cancelled'].includes(transaction.status),
      action: getItemAction(transaction),
    };
  });

  return <TransactionsTable rows={rows} />;
}
